import LogoComponent from "../../components/Logos/LogoComponent";
import defaultAvatar from "../../assets/sampleAvatar.png";
import { useContext, useState } from "react";
import { CurrentUserContext } from "../../App";
import SubmitButton from "../../components/buttons/SubmitButton";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3080";

export default function NewUsernamePage() {
  // intialize variables
  const [newUsername, setNewUsername] = useState("");
  const { currentUser, setCurrentUser } = useContext(CurrentUserContext);
  const navigate = useNavigate();

  function handleFormSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    fetch(`${API_URL}/updateUsername`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${currentUser?.token}`,
      },
      body: JSON.stringify({
        email: currentUser?.email,
        newUsername: newUsername,
      }),
    })
      .then((r) => r.json())
      .then((r) => {
        if ("success" === r.message) {
          setCurrentUser({ ...currentUser, username: newUsername });
          localStorage.setItem(
            "currentUser",
            JSON.stringify({ ...currentUser, username: newUsername })
          );
          navigate("/login/welcome");
        } else {
          alert(r.message);
        }
      });
  }

  return (
    // THIS CENTERS EVERYTHING
    <div className="d-flex flex-column min-vh-100 justify-content-center align-items-center">
      {/* THIS HOLDS THE STUFF */}
      <div
        className="d-flex flex-column justify-content-center align-items-center gap-2"
        style={{ maxWidth: "30rem", width: "30rem" }}
      >
        <LogoComponent />
        <div style={{ maxWidth: "8rem" }}>
          <img
            src={currentUser?.avatar && currentUser.avatar !== "sampleAvatar.png" ? currentUser.avatar : defaultAvatar}
            alt="Your Avatar"
            className="w-100 rounded-circle mb-3"
          />
        </div>
        {/* Header and Text */}
        <div className="mb-4 text-center w-100">
          <span
            className="main-purple fw-bold text-nowrap"
            style={{ fontSize: "2.4rem" }}
          >
            Enter a new username
          </span>
          <p style={{ fontSize: "1.2rem" }}>
            Enter a unique username which suits you
          </p>
        </div>

        <form onSubmit={handleFormSubmit} noValidate className="w-100">
          <div
            className="rounded-4 p-2 mb-4"
            style={{ border: "1px solid var(--main-purple)" }}
          >
            <input
              type="text"
              className="form-control border-0 w-100"
              onChange={(e) => setNewUsername(e.target.value)}
              value={newUsername}
              maxLength={14} // Limit usernames to 16 characters.
            />
          </div>
          {/* SUGGESTIONS AREA */}
          <div className="text-start mb-5">
            <span
              style={{ fontSize: "1.2rem" }}
              className="main-purple text-start"
            >
              Suggestions
            </span>
            <p className="main-purple">Suggestion for Username Goes Here</p>
          </div>
          <div className="d-flex flex-column gap-2 w-100">
            <SubmitButton
              buttonText={"Continue"}
              buttonValue={"submit"}
              className="btn  fw-bold mb-3 bg-main-purple"
            />
          </div>
        </form>
      </div>
    </div>
  );
}
